import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { environment } from 'src/environments/environment';
import { createRequestOption } from 'src/app/shared/util';
import { map } from 'rxjs/operators';

type EntityResponseType = HttpResponse<any>;
type EntityArrayResponseType = HttpResponse<any[]>;

@Injectable({ providedIn: 'root' })
export class MasterDataProductService {
  public resourceUrl = environment.SERVER_API_URL + 'api/product/';

  constructor(protected http: HttpClient) {}

  getRelationalOperator() {
    return this.http.get<any>(`${environment.SERVER_API_URL}api/relationalOperator/`, { observe: 'response' })
    .pipe(map((res: any) => {
      const result = res.body.data;
      return result;
    }));
  }
  getRiskLevel() {
    return this.http.get<any>(`${environment.SERVER_API_URL}api/riskLevel/`, { observe: 'response' })
    .pipe(map((res: any) => {
      const result = res.body.data;
      return result;
    }));
  }
  getDayOfWeek() {
    return this.http.get<any>(`${environment.SERVER_API_URL}api/daysOfWeek/`, { observe: 'response' })
    .pipe(map((res: any) => {
      const result = res.body.data;
      return result;
    }));
  }
  getAssets() {
    return this.http.get<any>(`${environment.SERVER_API_URL}api/assetAllocation/`, { observe: 'response' })
    .pipe(map((res: any) => {
      const result = res.body.data;
      return result;
    }));
  }
  getFundType() {
    return this.http.get<any>(`${environment.SERVER_API_URL}api/fundType/`, { observe: 'response' })
    .pipe(map((res: any) => {
      const result = res.body.data;
      return result;
    }));
  }
  getGoldType() {
    return this.http.get<any>(`${environment.SERVER_API_URL}api/fundType/`, { observe: 'response' })
    .pipe(map((res: any) => {
      const result = res.body.data;
      return result;
    }));
  }
  getFundAssetType() {
    return this.http.get<any>(`${environment.SERVER_API_URL}api/fundAssetType/`, { observe: 'response' })
    .pipe(map((res: any) => {
      const result = res.body.data;
      return result;
    }));
  }
  getBanks(req?: any) {
    const options = createRequestOption(req);
    return this.http.get(environment.SERVER_API_URL + 'api/dataBank/', { params: options, observe: 'response' });
  }
}
